import { Component, inject, Input } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,  
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';

@Component({
  selector: 'confirm-dialog',
  standalone: true,
  imports: [ MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose ],
  templateUrl: './confirmation-dialog.component.html',
})
export class ConfirmationDialog {
    readonly dialogRef = inject(MatDialogRef<ConfirmationDialog>);
    
    constructor() {}

    public confirmMessage!:string;
}